import { type FC } from 'react';
import classnames from 'classnames';

import { FormattedMessage, FormattedNumber } from 'dibs-react-intl';
import { Button } from 'dibs-elements/exports/Button.tsx';

import { useTradeApplyHandler } from '../applyHandler/TradeApplyHandlerProvider.tsx';
import { trackTradeBenefitsEvent } from '../tradeBenefitsTracking.ts';

import sharedStyles from '../TradeBenefitsSharedStyles.scss';
import styles from './TradeBenefitsNonTradeHero.scss';
import dibsCss from 'dibs-css';

const TradeBenefitsNonTradeHero: FC = () => {
    const applyHandler = useTradeApplyHandler();

    const handleApplyClick = (): void => {
        trackTradeBenefitsEvent({ stepInteractionName: 'apply now clicked', trigger: 'hero' });
        applyHandler();
    };

    return (
        <>
            <div className={classnames(sharedStyles.fullWidthContainer, styles.heroImage)} />
            <div
                className={classnames(
                    sharedStyles.fullWidthContainer,
                    styles.container,
                    dibsCss.pXlarge,
                    dibsCss.textWhite,
                    dibsCss.flex,
                    dibsCss.itemsCenter
                )}
            >
                <div
                    className={classnames(
                        dibsCss.wFull,
                        dibsCss.maxW1440px,
                        dibsCss.my0,
                        dibsCss.mxAuto
                    )}
                >
                    <div className={styles.content}>
                        <h1 className={classnames(styles.title, dibsCss.mt0, dibsCss.mbSmall)}>
                            <FormattedMessage
                                id="abt.TradeBenefitsNonTradeHero.title"
                                defaultMessage="The Trade 1st Program"
                            />
                        </h1>
                        <p className={styles.description}>
                            <FormattedMessage
                                id="abt.TradeBenefitsNonTradeHero.description"
                                defaultMessage="Trade 1st is our loyalty program designed specifically for interior design firms. Join for free and earn {points} point for every {amount} spent on 1stDibs. As you earn points, you can progress to higher tiers, unlocking even more benefits — including tailored sourcing support, expanded purchase protection, publicity opportunities, and more."
                                values={{
                                    points: <FormattedNumber value={1} />,
                                    amount: (
                                        <FormattedNumber
                                            value={1}
                                            style="currency"
                                            currency="USD"
                                            maximumFractionDigits={0}
                                        />
                                    ),
                                }}
                            />
                        </p>
                        <div className={styles.desktopOnly}>
                            <Button
                                onClick={handleApplyClick}
                                style="circle"
                                className={styles.desktopButton}
                                customColors={{
                                    background: 'sassyColorWhite',
                                    text: 'sassyColorNoir',
                                    hoverText: 'sassyColorNoir',
                                    hoverBackground: 'sassyColorAlabaster',
                                }}
                            >
                                <FormattedMessage
                                    id="abt.TradeBenefitsNonTradeHero.button"
                                    defaultMessage="Apply Now"
                                />
                            </Button>
                        </div>
                        <div className={styles.mobileOnly}>
                            <Button onClick={handleApplyClick} style="circle" fullWidth>
                                <FormattedMessage
                                    id="abt.TradeBenefitsNonTradeHero.button"
                                    defaultMessage="Apply Now"
                                />
                            </Button>
                        </div>
                        <div
                            className={classnames(
                                styles.credit,
                                dibsCss.absolute,
                                dibsCss.bottomXsmall,
                                dibsCss.rightXsmall,
                                dibsCss.textBodyXSmallHeavy
                            )}
                        >
                            <FormattedMessage
                                id="abt.TradeBenefitsNonTradeHero.credit"
                                defaultMessage="Molly Kidd Studio. Photo by Tim Lenz"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export { TradeBenefitsNonTradeHero };
